import { Person, LocalMallOutlined, StoreOutlined, CardGiftcardOutlined } from '@material-ui/icons';
import { capitalize } from 'lodash-es';

import {
  formatGiftCardNumber,
  nameOfMostExpensiveCartEntry,
  currencyToIsoCountryCodeMap,
} from 'components/utils';
import { routes } from 'utils/routing';

import { SearchResult } from './types';

export const searchResultDisplayMap = {
  CustomerDetails: {
    icon: (_result: SearchResult) => <Person />,
    tooltip: (_result: SearchResult) => 'Customer',
    route: (result: SearchResult) => `${routes.customer}/${result.id}`,
    display: (result: SearchResult) => 'email' in result && result.email,
  },
  Order: {
    icon: (_result: SearchResult) => <LocalMallOutlined />,
    tooltip: (_result: SearchResult) => 'Order',
    route: (result: SearchResult) =>
      'userId' in result && `${routes.customer}/${result.userId}${routes.orders}/${result.id}`,
    display: (result: SearchResult) => 'cart' in result && nameOfMostExpensiveCartEntry(result),
  },
  GiftCard: {
    icon: (_result: SearchResult) => <CardGiftcardOutlined />,
    tooltip: (_result: SearchResult) => 'Gift Card',
    // Derive country from currency: card-level currencyCode (from prepaidsBalance)
    // takes priority over transaction-level currencyCode (from first transaction).
    // Falls back to 'unknown' if neither is available (e.g. card with no transactions
    route: (result: SearchResult) => {
      const currency =
        ('currencyCode' in result ? result.currencyCode : undefined) ??
        ('transactions' in result ? result.transactions?.[0]?.currencyCode : undefined) ??
        '';
      const countryCode =
        (currencyToIsoCountryCodeMap as Record<string, string>)[currency] ?? 'unknown';
      return `${routes.giftCard}/${countryCode}/${result.id}`;
    },
    display: (result: SearchResult) => {
      if ('cardNumber' in result) {
        const currency =
          ('currencyCode' in result ? result.currencyCode : undefined) ??
          ('transactions' in result ? result.transactions?.[0]?.currencyCode : undefined) ??
          '';
        const countryCode =
          (currencyToIsoCountryCodeMap as Record<string, string>)[currency] ?? 'unknown';
        return `${countryCode} ${formatGiftCardNumber(result?.cardNumber ?? undefined)}`;
      }
    },
  },
  Store: {
    icon: (_result: SearchResult) => <StoreOutlined />,
    tooltip: (result: SearchResult) => `Store ${'storeNumber' in result && result.storeNumber}`,
    route: (result: SearchResult) => `${routes.store}/${result.id}`,
    display: (result: SearchResult) =>
      'storeAddress' in result &&
      'storeNumber' in result &&
      [result.storeAddress?.address1, result.storeAddress?.city]
        .filter(Boolean)
        .join(', ')
        .toLowerCase()
        .split(' ')
        .map((word) => capitalize(word))
        .join(' '),
  },
};
